import React from 'react';

export default function Contact() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Contact Me</h1>
      <p className="mb-4">
        I would love to stay in touch! Don't hesitate to reach out with any of the following means!
      </p>

      <ul className="list-disc pl-5 space-y-2 text-blue-600">
        <li>Email: <a href="mailto:j2885wan@uwaterloo.ca" className="underline">j2885wan@uwaterloo.ca</a></li>
        <li>Phone: <a href="tel:+14372684015" target="_blank" rel="noreferrer" className="underline">437-268-4015</a></li>
        <li>LinkedIn: <a href="https://www.linkedin.com/in/wangjieshen/" target="_blank" rel="noreferrer" className="underline">wangjieshen</a></li>
        <li>Also check out my software projects at my GitHub: <a href="https://github.com/jjieshenwang" target="_blank" rel="noreferrer" className="underline">jjieshenwang</a></li>
      </ul>
    </div>
  );
}
